import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { BiCaretLeft } from "react-icons/bi";
import { TbCurrencyRupee } from "react-icons/tb";
import CartCard from "./CartCard";
import { SERVER_PATH } from "../../config/env";
import { userInfo } from "../../utils/appInfo";
import { getLocalStorage } from "../../utils/helper";
import { ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";
import { errorToaster, successToaster } from "../../utils/index";
import { UserContext } from "./../../context/userContext";

export default function Cart() {
  const { updateUserData } = useContext(UserContext);
  const [data, setData] = useState([]);
  const [cartData, setCartData] = useState([]);
  const [taxData, setTaxData] = useState([]);
  let [cartValue, setCartValue] = useState(0);
  const [userData, setUserData] = useState({});
  const [courierPrice, setCourierPrice] = useState([]);
  const [stateData, setStateData] = useState({});
  const [isChecked, setIsChecked] = useState(0);

  // ✅ NEW (double order fix)
  const [isProcessing, setIsProcessing] = useState(false);

  const getUserId = () => {
    const user = userInfo();
    return user?.email || getLocalStorage("uid") || userData?.email || "";
  };

  const fetchData = async () => {
    try {
      const userId = getUserId();
      if (!userId) return;

      const { data: cData = [] } = await axios.post(
        `${SERVER_PATH}get/cart.php`,
        {
          user_id: userId,
        }
      );
      setData(Array.isArray(cData) ? cData : []);
      updateUserData({ cart: Array.isArray(cData) ? cData : [] });
    } catch (error) {
      setData([]);
    }
  };

  const fetchStateData = async () => {
    const userId = getUserId();
    if (!userId) return;

    await axios
      .post(`${SERVER_PATH}get/user.php`, {
        user_id: userId,
      })
      .then((res) => {
        setStateData(res.data[0] || {});
      });
  };

  useEffect(() => {
    if (stateData?.state) courierPriceData(stateData);
  }, [stateData]);

  const postCartData = (i) => {
    const userId = getUserId();
    if (!userId || !data[i]) return;

    axios
      .post(`${SERVER_PATH}put/cart.php`, {
        user_id: userId,
        product_id: data[i].product_id,
        quantity: data[i].quantity,
      })
      .then((res) => {
        setCartData(res.data);
      });
  };

  useEffect(() => {
    let value = 0;
    data.map((info) => {
      value = value + info.quantity * info.offer_price;
    });
    setCartValue(value);
  }, [data]);

  const removeProduct = async (id) => {
    const userId = getUserId();
    if (!userId) return;

    await axios
      .post(`${SERVER_PATH}delete/cart.php`, {
        user_id: userId,
        product_id: id,
      })
      .then((res) => {
        fetchData();
        errorToaster({ msg: "Item removed from your cart" });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const checkoutProduct = async () => {
    // ✅ prevent double click
    const userId = getUserId();
    if (!userId || isProcessing) return;

    setIsProcessing(true);

    let productID = data.map((d) => d.product_id);
    let quantity = data.map((d) => d.quantity);
    let product_name = data.map((d) => d.product_name);

    let deliveryCost =
      isChecked === 1
        ? 0
        : stateData?.state !== "0"
        ? getDeliveryCost()
        : 0;

    deliveryCost =
      data.length == 1 &&
      data.find((val) => val.product_name == "Health And Wellness")
        ? 0
        : deliveryCost;

    let totalOrderCost = cartValue + deliveryCost;

    let payload = {
      user_id: userId,
      order_cost: totalOrderCost,
      product_id: productID,
      quantity: quantity,
      product_name: product_name,
    };

    await axios
      .post(`${SERVER_PATH}post/payment.php`, payload)
      .then((res) => {
        if (res?.data?.pay_url) {
          window.location.href = res.data.pay_url;
        } else {
          setIsProcessing(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setIsProcessing(false);
      });
  };

  const courierPriceData = async (val = {}) => {
    await axios
      .post(`${SERVER_PATH}get/delivery_cost.php`, {
        state: val.state,
      })
      .then((res) => {
        setCourierPrice(res.data[0] || {});
      })
      .catch((err) => console.log(err));
  };

  const getTaxData = () => {
    axios.post(`${SERVER_PATH}get/additional_cost.php`, {}).then((res) => {
      setTaxData(res.data[0] || {});
    });
  };

  useEffect(() => {
    axios
      .get(`${SERVER_PATH}get/free_delivery.php`, {
        params: { sno: "1" },
      })
      .then((response) => {
        if (response.data.length > 0) {
          const fetchedValue = Number(response.data[0].free);
          setIsChecked(fetchedValue);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  const calculateBasePrice = (weight = 0) => {
    let cost = 0;
    if (!weight) return 0;

    if (weight <= 250) cost = courierPrice?.g250 || 0;
    else if (weight <= 500) cost = courierPrice?.g500 || 0;
    else if (weight <= 3000) {
      let remWeigh = weight - 500;
      let remCalc = Math.ceil(remWeigh / 500);
      cost = remCalc * (courierPrice?.upto3kg || 0) + Number(courierPrice?.g500 || 0);
    } else {
      let remCalc = Math.ceil(weight / 1000);
      cost = remCalc * (courierPrice?.above3kg || 0);
    }
    return cost;
  };

  const getDeliveryCost = () => {
    let weight = 0;
    data.map((item) => {
      let maxWeight = item.weight * item.quantity;
      weight = weight + maxWeight;
    });

    let accCost = calculateBasePrice(weight);
    accCost =
      Number(accCost) + (Number(accCost) * (taxData?.fuel || 0)) / 100;

    let netCost =
      Math.ceil(accCost) +
      (Math.ceil(accCost) * (taxData?.gst || 0)) / 100;

    return Math.ceil(netCost);
  };

  useEffect(() => {
    fetchData();
    fetchStateData();
    setUserData(userInfo() || { email: getUserId() });
    getTaxData();
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section className="h-100 h-custom productPage">
        <div className="container-fluid py-4 h-100">
          <div className="row d-flex justify-content-center align-items-center h-100">
            <div className="col">
              <div className="card">
                <div className="card-body p-4">
                  <div className="row">
                    <div className="col-lg-7">
                      <div className="mb-3">
                        <Link to="/" className="text-body text-decoration-none">
                          <BiCaretLeft
                            className="me-0"
                            style={{ fontSize: "1.5em", marginTop: "-5px" }}
                          />
                          <span>Continue shopping</span>
                        </Link>
                      </div>
                      <hr />

                      <div className="d-flex justify-content-between align-items-center mb-4">
                        <div>
                          <p className="mb-1">Shopping cart</p>
                          <p className="mb-0">
                            You have {data.length} items in your cart
                          </p>
                        </div>
                      </div>

                      <CartCard
                        cartData={(i) => postCartData(i)}
                        data={data}
                        deleteValue={removeProduct}
                        setData={setData}
                      />
                    </div>

                    <div className="col-lg-5">
                      <div className="card text-white rounded-3 shadow-sm" style={{ backgroundColor: "var(--secondary)", border: "1px solid var(--border)" }}>
                        <div className="card-body p-4">
                          <h4 className="text-uppercase fw-bold mb-3" style={{ color: "var(--text-light)", letterSpacing: "0.5px" }}>Price Details</h4>
                          <hr className="my-3" style={{ borderColor: "rgba(255,255,255,0.25)" }} />

                          <div className="d-flex justify-content-between align-items-center mb-2">
                            <p className="mb-0 text-uppercase" style={{ fontSize: "0.9rem", opacity: 0.9 }}>Sub Total</p>
                            <p className="mb-0 fw-bold fs-6">
                              <TbCurrencyRupee style={{ marginTop: "-3px" }} />
                              {cartValue}
                            </p>
                          </div>

                          <div className="d-flex justify-content-between align-items-center mb-2">
                            <p className="mb-0 text-uppercase" style={{ fontSize: "0.9rem", opacity: 0.9 }}>
                              {isChecked === 1
                                ? "Free Delivery"
                                : "Delivery charges"}
                            </p>
                            <p className="mb-0 fw-bold fs-6">
                              <TbCurrencyRupee style={{ marginTop: "-3px" }} />
                              {isChecked === 1
                                ? 0
                                : stateData?.state !== "0"
                                ? getDeliveryCost()
                                : 0}
                            </p>
                          </div>

                          <hr className="my-3" style={{ borderColor: "rgba(255,255,255,0.25)" }} />

                          <div className="d-flex justify-content-between align-items-center mb-4">
                            <p className="mb-0 text-uppercase fw-bold fs-5">Total Price</p>
                            <p className="mb-0 fw-bold fs-4" style={{ color: "var(--accent)" }}>
                              <TbCurrencyRupee style={{ marginTop: "-3px" }} />
                              {stateData?.state !== "0"
                                ? cartValue +
                                  (isChecked === 1 ? 0 : getDeliveryCost())
                                : cartValue}
                            </p>
                          </div>

                          {/* ✅ FIXED BUTTON */}
                          <button
                            disabled={!cartValue || isProcessing}
                            type="button"
                            className="btn w-100 py-2 fw-bold text-uppercase shadow-sm"
                            style={{
                              backgroundColor: "var(--accent)",
                              color: "#231815",
                              border: "none",
                              borderRadius: "8px",
                              letterSpacing: "0.8px",
                              fontSize: "0.95rem"
                            }}
                            onClick={() => {
                              if (!getUserId()) {
                                errorToaster({ msg: "Please login to proceed with your order." });
                                return;
                              }
                              if (!stateData?.state || stateData?.state == "0" || !stateData?.address || stateData?.address == "0") {
                                errorToaster({ msg: "Please provide your complete delivery address in your profile page before placing an order." });
                              } else {
                                checkoutProduct();
                              }
                            }}
                          >
                            {isProcessing ? "Processing..." : "Checkout"}
                          </button>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <ToastContainer />
    </>
  );
}